
  import { defineComponent, PropType } from 'vue';

  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';
  import { SectionTitleModes } from '@/common/components/redesigned/SectionTitle/types';

  import type { TEChartsTitleConfig } from './types';
  import { EChartsTitleModes } from './types';

  export default defineComponent({
    name: 'EChartsBase',
    components: { SectionTitle },
    props: {
      isEmpty: {
        type: Boolean,
        default: false,
      },
      emptyMessage: {
        type: String,
        default: 'Нет данных',
      },
      height: {
        type: Number,
      },
      width: {
        type: Number,
      },
      titleConfig: {
        type: Object as PropType<TEChartsTitleConfig>,
        default: () => ({
          text: '',
          level: 3,
        }),
      },
    },
    computed: {
      getChartHeightPx(): string | undefined {
        return this.getChartSizePx(this.height);
      },
      getChartWidthPx(): string | undefined {
        return this.getChartSizePx(this.width);
      },
      getIsShowBackground(): boolean {
        const mode = this.titleConfig.mode ?? EChartsTitleModes.DEFAULT;
        return mode === SectionTitleModes.BACKGROUND && !this.isEmpty;
      },
    },
    methods: {
      getChartSizePx(value?: number): string | undefined {
        if (!value) return undefined;
        return `${value}px`;
      },
    },
  });
